import { Injectable } from "@angular/core";

import { BaseService } from "../abstracts/base.service";
import { AddressModel } from "../models/address.model";
import { InstructorModel } from "../models/instructor.model";
import { ResultModel } from "../models/result.model";
import { map } from 'rxjs/operators';
import { ExamModel } from '../models/exam.model';
import { QuizModel } from '../models/quiz.model';

@Injectable({
  providedIn: "root",
})
export class QuizService extends BaseService {

  listAllForSelect(filter?: {ClassLevelID?: string, LessonID?: string, MajorID?: string}) {
    if(filter == null || !(filter.ClassLevelID || filter.LessonID || filter.MajorID )) // variables are null or emty
      return this.httpClient.get<ResultModel<QuizModel[]>>(this.getApiUrl("quizzes"));
    else
      return this.httpClient.get<ResultModel<QuizModel[]>>(this.getApiUrl("quizzes?") + this.getQueryString(filter));
  }

  listAll(formData?: FormData) {
    return this.httpClient.post<ResultModel<QuizModel[]>>(this.getApiUrl("quizzes/list"), formData);
  }

  create(quiz: QuizModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl("quizzes"), quiz);
  }

  update(quiz: QuizModel) {
    return this.httpClient.put<ResultModel>(this.getApiUrl("quizzes"), quiz);
  }

  get(id: string) {
    return this.httpClient.get<{ Quiz: QuizModel, QuizAnswers: any[] }>(this.getApiUrl("quizzes/" + id));
  }

  delete(id: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl("quizzes/" + id));
  }

  updateProfile(instructor: {InstructorID: string, Email: string, PhoneNumber: string, VirtualClassProviderUrl: string}) {
    return this.httpClient.put<ResultModel>(this.getApiUrl("quizzes/profile"), instructor);
  }

}
